import React, { useState } from 'react';
import axios from "axios"
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  PostalCodeElement,
  useStripe,
  useElements,
  Elements
} from '@stripe/react-stripe-js';





function Stripe() {
  const stripe = useStripe();
  const elements = useElements();
  const [paymentError, setPaymentError] = useState(null);

  // const handleSubmit = async (event) => {
  //   event.preventDefault();

  //   if (!stripe || !elements) {
  //     return;
  //   }

  //   try {
  //     const { token, error } = await stripe.createToken(elements);

  //     if (error) {
  //       console.error(error);
  //       setPaymentError(error.message);
  //     } else {
  //       // Send the token to your server
  //       const response = await fetch('http://localhost:4242/create-payment-intent', {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify({ amount: 12000, currency: 'usd' }), // Adjust amount and currency
  //       });

  //       const { clientSecret } = await response.json();

  //       // Confirm the payment on the client
  //       const { paymentIntent, error } = await stripe.confirmCardPayment(clientSecret, {
  //         payment_method: {
  //           card: elements.getElement(CardNumberElement),
  //           billing_details: {
  //             // Add additional details if needed
  //           },
  //         },
  //       });

  //       if (error) {
  //         console.error(error);
  //         setPaymentError(error.message);
  //       } else {
  //         console.log('Payment confirmed:', paymentIntent);
  //         // Handle successful payment confirmation
  //       }
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setPaymentError('Error processing payment');
  //   }
  // };

  const handlePayment = async (event) => {
    event.preventDefault();
    const response = await axios.post(
      `http://localhost:3003/api/create-payment-intents`,
      {
        amount: 1300,
      },
    );
    if (response.status === 200) {
      const confirmPayment = await stripe.confirmCardPayment(
        response.data.clientSecret,
        {
          payment_method: {
            card: elements.getElement(CardNumberElement),
          },
        }
      );
      if (confirmPayment.paymentIntent.status === "succeeded") {
        console.log('payment confirmed');
      }
    }
  }

  return (
    <div className='container'>


      <form className='payment-form' onSubmit={handlePayment}>
        <label htmlFor="card-number" className='form-label'>
          Card Number
        </label>
        <CardNumberElement id="card-number" className='card-element' />

        <label htmlFor="card-expiry" className='form-label'>
          Expiry Date
        </label>
        <CardExpiryElement id="card-expiry" className='card-element' />

        <label htmlFor="card-cvc" className='form-label'>
          CVC
        </label>
        <CardCvcElement id="card-cvc" className='card-element' />

        <button type="submit" disabled={!stripe} className='pay-button'>
          Pay
        </button>

        {paymentError && <div className='error-message'>{paymentError}</div>}
      </form>
    </div>
  );
}

export default Stripe;
